/**
 * Method behaving similar to Math.trunc
 * Reasons for implementing:
 * - Math.trunc is not supported in IE
 * - importing trunc polyfill from core-js library impacts bundle size
 */
export function trunc(x: number): number {
  return x >= 0 ? Math.floor(x) : Math.ceil(x);
}
